import { ReactElement } from "react";
import HorizontalRule from "../../HorizontalRule/HorizontalRule";



export function FormFieldWrapperColumn({ children, label, className }: { children: ReactElement, label: string, className?: string }) {
    return (<>
        <div className={`p-2 ${className}`}>
            <span className="w-full font-bold">{label}</span>
            <div className="w-full mt-2">
                {children}
            </div>
        </div>

        </>)
}